<template>
  <div class="registeredCam">
    <setting-header />
    <v-spacer class="registeredCam_gap-header" />
    <span class="registeredCam_name">名前</span>
    <v-text-field
      v-model="camName"
      height="40px"
      color="dark"
      class="registeredCam_input-name"
      required
      dense
      outlined
    />
    <div class="registeredCam_footer">
      <h3>このカメラの情報を削除する</h3>
      <v-btn
        text
        icon
        class="registeredCam_btn-delete"
        @click="$emit('onDelete')"
      >
        <span class="icon icon-trash" />
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import SettingHeader from './SettingHeader.vue';

export default {
  name: 'RegisteredCam',
  components: {
    SettingHeader,
  },
  props: {
    cameraId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      camName: '',
    };
  },
  computed: {
    ...mapState({
      registeredCams: (state) => state.settings.registeredCams,
    }),
    camera() {
      return this.registeredCams.find((cam) => cam.id === this.cameraId);
    },
  },
  mounted() {
    this.camName = this.camera.camName;
  },
};
</script>

<style lang="scss">
.registeredCam {
  &_gap-header {
    height: 26px;
  }
  &_name {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: #666;
  }
  &_input-name {
    margin-top: 10px !important;
    max-width: 500px;
    &.theme--light.v-input {
      input {
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.38;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
      }
    }
  }
  &_footer {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    padding: 9px 0;
    h3 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
  }
  &_btn-delete {
    .icon-trash {
      font-size: 16px;
      color: #989898;
    }
  }
}
</style>
